// import { Types } from '@marriott/mi-ui-library';

// const { tags } = Types;

export enum AHeaderSize {
  TitleXL = 'Title XL',
  TitleL = 'Title L',
  TitleM = 'Title M',
  TitleS = 'Title S',
}

// export type AHeaderTag = Extract<Types.tags, Types.tags.h1 | Types.tags.h2 | Types.tags.h3>;
// export const AHeaderTag = {
//   [tags.h1]: tags.h1,
//   [tags.h2]: tags.h2,
//   [tags.h3]: tags.h3,
// } as const;
export enum AHeaderTag {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
}

export interface AHeaderProps extends React.HTMLAttributes<HTMLHeadingElement> {
  text: string;
  /**
   * @deprecated Use `headerTag` instead. `headerTag` takes precedence when both are provided.
   *   This prop is retained for backward compatibility and will be removed in a future major version.
   */
  element?: AHeaderTag;
  headerTag?: AHeaderTag;
  size?: AHeaderSize;
}
